module.exports = __webpack_public_path__ + "img/display_campaign.fa277630.svg";